import { apolloProvider } from '@/modules/GraphQL';
import { GET_PDF } from '@/graphql/Mystage/material';
import { bizmatesApi } from '@/utils/bizmatesApi';
import logger from '@/modules/Logger';
import store from '@/store';

export const GetPdfService = {
  // Method to fetch PDF from new GraphQL endpoint
  new: async (lessonId, materialId, isTrial, isLessonTest, isDefaultLayout) => {
    logger.info(`[Materials][PDF] Fetching PDF from new GraphQL endpoint`, {
      operation: 'materials:get_pdf'
    });

    const client = apolloProvider.defaultClient;
    const { data } = await client.query({
      query: GET_PDF,
      fetchPolicy: 'no-cache',
      variables: {
        b: parseInt(lessonId),
        m: parseInt(materialId),
        dl: +isDefaultLayout
      }
    });

    if (data?.get_pdf) {
      store.commit('material/setPdfUrl', data.get_pdf.url);  // Storing the PDF URL
    } else {
      logger.error(`[Materials][PDF] Empty result from PDF GraphQL API`, {
        operation: 'materials:get_pdf',
        event_type: 4,
        lesson_id: lessonId
      });
    }
  },

  // Method to fetch PDF from legacy REST API endpoint
  legacy: async (lessonId, materialId, isTrial, isLessonTest, isDefaultLayout, jwtKeyValue) => {
    logger.info(`[Materials][PDF] Fetching PDF from legacy endpoint`, {
      operation: 'materials:get_pdf'
    });

    let path = isLessonTest ? 'materials/testPdf.json' : 'materials/pdf.json';
    if (isTrial) {
      path = 'sales/pdf';
    }
    const params = {
      b: lessonId,
      m: materialId,
      dl: +isDefaultLayout,
      ...(isTrial && jwtKeyValue),
    };

    await bizmatesApi.get(path, { params }, (response) => {
      if (response.data?.url) {
        store.commit('material/setPdfUrl', response.data.url);  // Storing the PDF URL
      } else {
        logger.error(`[Materials][PDF] Empty result from legacy PDF API`, {
          operation: 'materials:get_pdf',
          event_type: 4,
          lesson_id: lessonId
        });
      }
    });
  }
};
